module.exports = __webpack_public_path__ + "img/at.ec18038.svg";